import React from 'react';
import ReactDOM from 'react-dom';
import ArtistPage from './app/app';
import { Provider } from 'react-redux';
import store from './data/store';

/**
 * entry point
 */
const init = () => {
    const $root = document.getElementById('artist-page-react-app');
    if (!$root) return;

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={ store }>
                <ArtistPage />
            </Provider>
        </React.StrictMode>,
        $root
    );
};

init();